module.exports = __webpack_public_path__ + "static/media/send.4df4c7fc.svg";